/* eslint-disable parog-web/no-glint-expect-error-directive */
import Component from '@glimmer/component';
import type { Signature as ForcProviderBaseSignature } from 'parog-web/components/forc/provider/base';
import type Patient from 'parog-web/models/patient';
import eq from 'ember-truth-helpers/helpers/eq';
import tnmClassificationCodes from 'parog-web/helpers/tnm-classification-codes';
import or from 'ember-truth-helpers/helpers/or';
import MaritalStatusDropdown from 'parog-web/components/lifestyle/edition/marital-status-dropdown';
import ModelList from 'parog-web/components/model-list';
import Descendant from 'parog-web/components/administrative-patient/descendant';

export interface Signature {
  Element: HTMLDivElement;
  Args: {
    Input?: unknown;
    TextArea?: unknown;
    Dropdown?: unknown;
    BasicRadioGroup?: unknown;
    Date?: unknown;
    patient: Patient;
    form: ForcProviderBaseSignature['Blocks']['default'][0];
  };
}
export default class MedicalHistoryOncoBaseCancerForm extends Component<Signature> {
  eq = eq;
  tnmClassificationCodes = tnmClassificationCodes;

  <template>
    <div class='field' ...attributes>
      <div class='two fields'>
        <div class='ten wide field'>
          <@form.Date
            @labelName='Date du diagnostic'
            @propertyName='diagnosisDate'
          />
        </div>
        <div class='six wide field'>
          <@form.BasicRadioGroup
            @title='Stade'
            @propertyName='stage'
            as |Group|
          >
            <div class='fields inline'>
              <div class='field'>
                <Group.Radio @label='0' @value='1' />
              </div>
              <div class='field'>
                <Group.Radio @label='1' @value='2' />
              </div>
              <div class='field'>
                <Group.Radio @label='2' @value='3' />
              </div>
              <div class='field'>
                <Group.Radio @label='3' @value='4' />
              </div>
              <div class='field'>
                <Group.Radio @label='4' @value='5' />
              </div>
            </div>
          </@form.BasicRadioGroup>
        </div>
      </div>

      {{!    TNM CLASSIFICATION     }}

      <div class='field'>
        <label>Classification TNM</label>
        <div class='three fields'>
          <div class='field'>
            <@form.Dropdown @propertyName='tnmClassification.t' as |dropdown|>
              {{#each (this.tnmClassificationCodes 't') as |key|}}
                <dropdown.Item @key={{key}} @value={{key}} />
              {{/each}}
            </@form.Dropdown>
          </div>

          <div class='field'>
            <@form.Dropdown @propertyName='tnmClassification.n' as |dropdown|>
              {{#if
                (or
                  (this.eq @patient.followUpReason 'onco-breast-cancer')
                  (this.eq @patient.followUpReason 'onco-breast-cancer-tnm0')
                )
              }}
                {{#each (this.tnmClassificationCodes 'nBreastCancer') as |key|}}
                  <dropdown.Item @key={{key}} @value={{key}} />
                {{/each}}
              {{else}}
                {{#each (this.tnmClassificationCodes 'nOthersCancer') as |key|}}
                  <dropdown.Item @key={{key}} @value={{key}} />
                {{/each}}
              {{/if}}
            </@form.Dropdown>
          </div>

          <div class='field'>
            <@form.Dropdown @propertyName='tnmClassification.m' as |dropdown|>
              {{#each (this.tnmClassificationCodes 'm') as |key|}}
                <dropdown.Item @key={{key}} @value={{key}} />
              {{/each}}
            </@form.Dropdown>
          </div>
        </div>
      </div>
      <div class='field'>
        <@form.TextArea
          @propertyName='tnmComment'
          @placeholder='vous pouvez ajouter un commentaire...'
          @rows={{2}}
        />
      </div>

      {{#if (has-block 'content')}}
        <div class='ui divider'></div>
        {{! @glint-expect-error }}
        {{yield to='content'}}
      {{/if}}

      <div class='field'>
        <MaritalStatusDropdown @changeset={{@form.changeset}} />
      </div>

      <div class='field'>
        <label>Descendance</label>
        <@form.ConditionalRadioGroup
          @propertyName='hasChildren'
          @conditionalValue={{true}}
          as |ConditionalRadioGroup showConditionalBlock|
        >
          <div class='field'>
            <ConditionalRadioGroup.AlignedFieldsRadioGroup as |Group|>
              <Group.FieldRadio @value={{true}} @label='Oui' />
              <Group.FieldRadio @value={{false}} @label='Non' />
            </ConditionalRadioGroup.AlignedFieldsRadioGroup>
          </div>

          {{#if showConditionalBlock}}
            <ModelList
              @listClass='ui segments'
              @model={{@form.changeset}}
              @propertyName='children'
              @addButtonTitle='Ajouter un enfant'
              as |Item|
            >
              <Descendant
                @title='enfant'
                @model={{Item.item}}
                @index={{Item.index}}
                @onDestroy={{Item.destroy}}
                data-test-child={{Item.index}}
              />
            </ModelList>
          {{/if}}
        </@form.ConditionalRadioGroup>
      </div>
      <div class='field'>
        <@form.Input @propertyName='job' @labelName='Emploi' />
      </div>
    </div>
  </template>
}
